export default __webpack_public_path__ + "static/yahoo-news-3a0bef192abb5de5269ab36a8fd45cbd.png";